import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import TitleBar from 'components/TitleBar';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(5),
  },
  form: {
    padding: '1em',
  },
  button: {
    width: '150px',
    margin: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  title: {
    flexGrow: 1,
  },
}));

export default function CreateOrJoin() {
  const classes = useStyles();
  const [title, setTitle] = useState('');

  const history = useHistory();
  const submit = () => {
    if (title) {
      history.push(`/classroom?title=${encodeURIComponent(title)}`);
    }
  };

  return (
    <>
      <TitleBar />
      <Box display="flex" flexDirection="row" justifyContent="center" className={classes.root}>
        <Paper elevation={3} className={classes.paper}>
          <Typography variant="h4">Join</Typography>
          <Box display="flex" flexDirection="column" className={classes.form}>
            <Input
              inputProps={{ 'data-testid': 'title' }}
              onChange={(event) => setTitle(event.target.value)}
              placeholder="Meeting Title"
            />
          </Box>
          <Box marginLeft={2} display="flex" flexDirection="row" justifyContent="center">
            <Button onClick={submit} variant="contained" color="primary" className={classes.button}>
              Submit
            </Button>
          </Box>
        </Paper>
      </Box>
    </>
  );
}
